import { isBrowser, getBaseURL } from '../../../utils';

export const fetchGuidedRecipe = async (id: string) => {
  const response = await fetch(
    `${
      isBrowser() ? getBaseURL() : 'https://zapier.com'
    }/api/v4/guided-recipes/${id}/`,
  );
  if (!response.ok) {
    console.error('Error fetching Guided Recipe with ID ' + id);
    return {
      title: '',
      service: [],
      href: '',
    };
  }

  const responseJSON = await response.json();

  const services = responseJSON.services?.map(
    (service: { name: string; images?: { url_64x64: string } }) => ({
      name: service.name,
      src: service.images?.url_64x64,
    }),
  );
  return {
    title: responseJSON.title,
    services,
    href: `https://zapier.com${responseJSON.guided_recipe_url}`,
    color: `#${responseJSON.head_service?.primary_color}`,
  };
};
